/** In-memory cache for document viewer metadata, text, and signed file URLs. */

const metaCache = new Map();
const textCache = new Map();
const fileUrlCache = new Map();

const FILE_URL_REFRESH_MS = 5 * 60 * 1000;

export function getCachedMeta(id) {
  return metaCache.get(id) || null;
}

export function setCachedMeta(id, meta) {
  if (!id || !meta) return;
  metaCache.set(id, meta);
}

export function getCachedText(id) {
  return textCache.get(id) || null;
}

export function setCachedText(id, payload) {
  if (!id || !payload) return;
  textCache.set(id, payload);
}

export function getCachedFileUrl(id) {
  return fileUrlCache.get(id) || null;
}

export function setCachedFileUrl(id, fileMeta) {
  if (!id || !fileMeta?.url) return;
  const expiresInMs = (fileMeta.expires_in || 3600) * 1000;
  fileUrlCache.set(id, {
    ...fileMeta,
    expiresAt: Date.now() + expiresInMs,
  });
}

export function isFileUrlExpired(fileMeta) {
  if (!fileMeta?.expiresAt) return true;
  return Date.now() >= fileMeta.expiresAt - FILE_URL_REFRESH_MS;
}

export function invalidateDocument(id) {
  if (!id) return;
  metaCache.delete(id);
  textCache.delete(id);
  fileUrlCache.delete(id);
}

export function mergeDocWithText(meta, textPayload) {
  if (!meta) return null;
  if (!textPayload) return { ...meta };
  return {
    ...meta,
    text: textPayload.text,
    page_offsets: textPayload.page_offsets ?? meta.page_offsets,
  };
}
